(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bs-wheelio-gate"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__BS_WHEELIO_GATE__) return;
  window.__BS_WHEELIO_GATE__ = '2026-09-15.4';

  var assignmentCookie = 'bs_wheelio_arm';
  var exposureCookie = 'bs_wheelio_seen';
  var emailOriginCookie = 'bs_email_origin';
  var sessionKey = 'bs_wheelio_invoked';
  var eligibleAt = Date.now() + 5000;
  var purchaseWindowUntil = 0;
  var params = new URLSearchParams(window.location.search);
  var previewMode = params.has('preview_theme_id') || Boolean(window.Shopify && (window.Shopify.designMode || window.Shopify.theme && /^(unpublished|development)$/.test(window.Shopify.theme.role)));
  var forcedArm = previewMode ? params.get('bs-wheelio-arm') : '';
  var diagnosticEnabled = previewMode && params.get('bs-wheelio-debug') === '1';
  var diagnostic;
  if (previewMode) {
    var previewSuffix = '_preview_' + (params.get('bs-wheelio-run') || 'default').replace(/[^a-z0-9_-]/gi, '').slice(0,32);
    assignmentCookie += previewSuffix;
    exposureCookie += previewSuffix;
    emailOriginCookie += previewSuffix;
    sessionKey += previewSuffix;
  }
  var purchaseSessionKey = sessionKey + '_purchase';

  function readCookie(name) {
    var prefix = name + '=';
    var item = document.cookie.split('; ').find(function (part) {
      return part.indexOf(prefix) === 0;
    });
    return item ? decodeURIComponent(item.slice(prefix.length)) : '';
  }

  function writeCookie(name, value, maxAge) {
    document.cookie = name + '=' + encodeURIComponent(value) + '; Path=/; Max-Age=' + maxAge + '; SameSite=Lax; Secure';
  }

  function chooseArm() {
    if (forcedArm === 'treatment' || forcedArm === 'control') {
      writeCookie(assignmentCookie, forcedArm, 31536000);
      return forcedArm;
    }
    var existing = readCookie(assignmentCookie);
    if (existing === 'treatment' || existing === 'control') return existing;
    var sample = new Uint32Array(1);
    window.crypto.getRandomValues(sample);
    var selected = sample[0] % 2 === 0 ? 'control' : 'treatment';
    writeCookie(assignmentCookie, selected, 31536000);
    return selected;
  }

  function hasEmailOrigin() {
    var source = (params.get('utm_source') || '').toLowerCase();
    var medium = (params.get('utm_medium') || '').toLowerCase();
    var identified = params.has('omnisendContactID') || params.has('omnisendAttributionID') || params.has('omnisendScopeID');
    if (identified || source.indexOf('omnisend') !== -1 || medium === 'email') {
      writeCookie(emailOriginCookie, '1', 2592000);
      return true;
    }
    return readCookie(emailOriginCookie) === '1';
  }

  function excludedPath() {
    var path = window.location.pathname.toLowerCase().replace(/\/$/, '') || '/';
    if (/^\/(cart|checkout)(\/|$)/.test(path)) return true;
    if (/^\/policies\/(privacy-policy|terms-of-service)(\/|$)/.test(path)) return true;
    if (/^\/pages\/(privacy-statement|barista-swag-spin-to-win-promotion-terms)(\/|$)/.test(path)) return true;
    return /(experience|booking|workshop|event)/.test(path);
  }

  function purchaseState() {
    if (Date.now() < purchaseWindowUntil) return true;
    if (sessionStorage.getItem(purchaseSessionKey) === '1') return true;
    if (document.body.classList.contains('bs-cart-open')) return true;
    if (document.body.classList.contains('bs-stage-commerce-active')) return true;
    if (sessionStorage.getItem('bs_white_drawer_open') === '1') return true;
    return Boolean(document.querySelector('#bs-cart-drawer-root[aria-hidden="false"], form[data-bs-submitting="true"], form[action*="/cart/add"] [aria-busy="true"]'));
  }

  function updateDiagnostic(state) {
    document.documentElement.dataset.bsWheelioArm = arm;
    document.documentElement.dataset.bsWheelioGateState = state;
    if (!diagnosticEnabled) return;
    if (!diagnostic) {
      diagnostic = document.createElement('output');
      diagnostic.id = 'bs-wheelio-gate-diagnostic';
      diagnostic.style.cssText = 'position:fixed;left:8px;bottom:8px;z-index:2147483647;padding:8px 10px;background:#111;color:#fff;font:12px/1.3 monospace;border-radius:4px';
      document.body.appendChild(diagnostic);
    }
    diagnostic.textContent = arm + ' | ' + state;
  }

  function markPurchaseWindow() {
    purchaseWindowUntil = Math.max(purchaseWindowUntil, Date.now() + 15000);
    sessionStorage.setItem(purchaseSessionKey, '1');
    updateDiagnostic('purchase-suppressed');
  }

  function attemptOpen() {
    if (!window.matchMedia('(min-width: 769px) and (hover: hover) and (pointer: fine)').matches) return updateDiagnostic('mobile-suppressed');
    if (arm !== 'treatment') return updateDiagnostic('control');
    if (Date.now() < eligibleAt) return updateDiagnostic('waiting-five-seconds');
    if (excludedPath()) return updateDiagnostic('excluded-path');
    if (emailOrigin) return updateDiagnostic('email-origin-suppressed');
    if (purchaseState()) return updateDiagnostic('purchase-suppressed');
    if (sessionStorage.getItem(sessionKey) === '1') return updateDiagnostic('session-suppressed');
    if (readCookie(exposureCookie) === '1') return updateDiagnostic('seven-day-suppressed');
    var target = document.getElementById('bs-wheelio-gate-trigger');
    if (!target) return updateDiagnostic('target-missing');
    sessionStorage.setItem(sessionKey, '1');
    writeCookie(exposureCookie, '1', 604800);
    updateDiagnostic('invoked');
    target.click();
  }

  var arm = chooseArm();
  var emailOrigin = hasEmailOrigin();
  var purchaseSelector = 'form[action*="/cart/add"], button[name="add"], [data-add-to-cart], [data-bs-open-cart], a[href="/cart"], a[href$="/cart"], button[aria-controls="cart-drawer"], button[name="checkout"], #checkout';

  document.addEventListener('pointerdown', function (event) {
    if (event.target.closest(purchaseSelector)) markPurchaseWindow();
  }, true);

  document.addEventListener('submit', function (event) {
    if (event.target.matches('form[action*="/cart/add"], form[action*="/checkout"]')) markPurchaseWindow();
  }, true);

  document.addEventListener('bs:analytics', function (event) {
    var name = event.detail && event.detail.event || '';
    if (/cart|drawer|checkout|pitcher_added/.test(name)) markPurchaseWindow();
  });

  document.addEventListener('pointerout', function (event) {
    if (!event.isTrusted) return;
    if (event.pointerType && event.pointerType !== 'mouse') return;
    if (event.relatedTarget !== null) return;
    if (event.clientY > 0) return;
    attemptOpen();
  }, true);

  updateDiagnostic(excludedPath() ? 'excluded-path' : arm === 'control' ? 'control' : emailOrigin ? 'email-origin-suppressed' : 'waiting-five-seconds');
}());
  } catch(e) { console.error(e); }
})();

})();
